export default "__VITE_ASSET__arzFKgvz__"